// @flow
export const FQDN_MAX_LENGTH = 63;

export default null;
